import React, { forwardRef } from "react";
import {
  Button as ChakraButton,
  ButtonProps as ChakraButtonProps,
} from "@chakra-ui/react";
import {
  useAnalyticsTag
} from "../../utils/AnalyticsTagScopeProvider";

export interface ButtonProps extends Omit<ChakraButtonProps, "colorScheme"> {
  href?: string;
}

const Button = forwardRef(function ButtonWrapper(props: ButtonProps, ref) {
  const defaultAnalyticsTagSuffix = `${props.variant ? props.variant + "-" : ""}button`;
  const computedAnalyticsTag = useAnalyticsTag(defaultAnalyticsTagSuffix)
  return <ChakraButton ref={ref} {...computedAnalyticsTag} {...props} />;
});

export default Button;
